import { EboObjectTimeLine } from '../../base-classes/ebo-object-time-line';

export class TruckOdometerOffset extends EboObjectTimeLine {
  truckID: string;
  applyToMaintenance: boolean;
  applyToIvmr: boolean;

  actualValue: number;
  odometerOffset: number;

  constructor(data: Partial<TruckOdometerOffset> = {}) {
    super(data);
    this.applyToMaintenance ??= false;
    this.applyToIvmr ??= true;
  }
}
